import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';

const initialState = {
    isSubmit: false,
    isFail: false,
    isGetItem: false,
    isFetchingUpdate: false,
    dataList: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    roomTypeByHotel: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.ROOM_TYPE_LIST_ACTION:
            return { ...state, isFetching: true, dataList: [] };
        case Types.HOTEL_DETAIL_SUCCESS:
            return { ...state, pageIndex: PAGINATION.pageIndex, }
        case Types.ROOM_TYPE_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false,
                dataList: action.dataList,
                isSubmit: false,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.ROOM_TYPE_LIST_FAIL:
            return { ...state, isFetching: false };
        case Types.ROOM_TYPE_DETAIL_ACTION:
            return { ...state, isFetching: true, roomType: {} };
        case Types.ROOM_TYPE_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false,
                roomType: action.roomType
            };
        case Types.ROOM_TYPE_DETAIL_FAIL:
            return { ...state, isFetching: false };
        case Types.ROOM_TYPE_SAVE_ACTION:
            return { ...state, isFetching: true };
        case Types.ROOM_TYPE_SAVE_SUCCESS:
            return {
                ...state,
                isFetching: false,
                roomType: action.roomType
            };

        case Types.ROOM_TYPE_SAVE_FAIL:
            return { ...state, isFetching: false, roomType: action.roomType };
        case Types.ROOM_TYPE_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.ROOM_TYPE_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.ROOM_TYPE_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.ROOM_TYPE_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.ROOM_TYPE_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.ROOM_TYPE_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.ROOM_TYPE_ALL_HOTEL_ACTION:
            return { ...state, isFetchingUpdate: true, roomTypeByHotel: [] };
        case Types.ROOM_TYPE_ALL_HOTEL_SUCCESS:
            return { ...state, isFetchingUpdate: false, roomTypeByHotel: action.roomType };
        case Types.ROOM_TYPE_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        default:
            return state;
    }
}
